export enum InstructorCnhCategory {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}
